export const NAV = [
  { id: "metodo", label: "Método" },
  { id: "resultados", label: "Resultados" },
  { id: "servicos", label: "Serviços" },
  { id: "sobre", label: "Sobre" },
  { id: "artigos", label: "Artigos" },
  { id: "faq", label: "FAQ" },
];

export const HERO_STATS = [
  { v: "25+", l: "anos de experiência" },
  { v: "180+", l: "projetos entregues" },
  { v: "10+", l: "setores atendidos" },
  { v: "5", l: "etapas do método" },
];

export const PAINS = [
  "Marketing sem conexão com vendas",
  "Leads sem qualificação",
  "Metas sem processo",
  "Crescimento sem previsibilidade",
  "Decisões sem indicadores",
];

export const RESULTS = [
  { v: "+35%", l: "em leads qualificados", c: "Teklamatik · Tecnologia & B2B" },
  { v: "−40%", l: "no CAC", c: "Teklamatik · Tecnologia & B2B" },
  { v: "+45%", l: "em agendamentos executivos", c: "Med-Rio Check-up · Saúde" },
  { v: "+50%", l: "em vendas online em 5 meses", c: "Flô Maria · Varejo & E-commerce" },
  { v: "+55%", l: "em vendas no PDV em 3 meses", c: "Foods Brands · Food Service" },
];

export const METRICS = [
  { n: 180, s: "+", l: "Projetos entregues", d: "[placeholder] Projetos de marketing, vendas e estratégia empresarial." },
  { n: 10, s: "+", l: "Setores atendidos", d: "[placeholder] Da indústria aos serviços, do B2B ao varejo." },
  { n: 25, s: "+", l: "Anos de experiência", d: "[placeholder] Liderando áreas de marketing e comercial." },
];

export const TESTIMONIALS = [
  {
    co: "Teklamatik", s: "Tecnologia & B2B",
    q: "O Maicon não apenas desenhou a estratégia, mas acompanhou de perto a implementação prática com os nossos times de marketing e vendas. A reestruturação dos canais reduziu nosso CAC e elevou o volume de leads qualificados.",
    n: "Fernando Bastos", r: "Diretor de Operações e Tecnologia · Teklamatik",
    res: ["−40% no CAC", "+35% em leads qualificados"],
  },
  {
    co: "Med-Rio Check-up", s: "Saúde & Medicina Preventiva",
    q: "A conexão entre posicionamento institucional e relacionamento com decisores foi cirúrgica. A comunicação ganhou clareza, ética e alto padrão.",
    n: "Drª. Valéria Mendes", r: "Diretora de Relações Corporativas · Med-Rio Check-up",
    res: ["+45% em agendamentos executivos"],
  },
  {
    co: "Flô Maria", s: "Varejo & E-commerce",
    q: "O diagnóstico da jornada de compra e a reestruturação dos canais digitais trouxeram evolução sustentável para as vendas online.",
    n: "Camila Rocha", r: "Fundadora e Diretora Comercial · Flô Maria",
    res: ["+50% em vendas online em 5 meses"],
  },
  {
    co: "Foods Brands", s: "Food Service & Varejo Físico",
    q: "A integração entre campanhas orientadas por dados e o alinhamento da equipe fez o planejamento virar resultado real no caixa.",
    n: "Ricardo Nogueira", r: "Head de Expansão e Franquias · Foods Brands",
    res: ["+55% em vendas no PDV em 3 meses"],
  },
];

export const SERVICES = [
  {
    t: "Estratégia de Marketing e Posicionamento",
    d: "Definição de público, proposta de valor e posicionamento para que sua marca seja percebida pelo que realmente entrega.",
    items: ["Diagnóstico de marca e mercado", "Proposta de valor e mensagem", "Plano de marketing com metas"],
  },
  {
    t: "Estratégia Comercial e Crescimento de Vendas",
    d: "Construa e aplique a estratégia comercial ideal para o seu negócio, com um plano de ação detalhado e focado em resultados mensuráveis.",
    items: ["Estruturação do funil comercial", "Processos, rituais e metas", "Indicadores de desempenho"],
  },
  {
    t: "Consultoria Estratégica Empresarial",
    d: "Apoio na definição de prioridades, modelo de crescimento e alinhamento entre áreas para decisões mais seguras.",
    items: ["Planejamento estratégico", "Prioridades e roadmap", "Governança e acompanhamento"],
  },
  {
    t: "Liderança Executiva de Marketing e Comercial",
    d: "Atuação executiva na condução das áreas de marketing e vendas, com responsabilidade sobre metas e time.",
    items: ["Gestão de times", "Condução de metas", "Rituais de performance"],
  },
  {
    t: "Mentorias e Desenvolvimento Profissional",
    d: "Mentoria individual ou em grupo para líderes e profissionais que querem acelerar resultados com método.",
    items: ["Mentoria individual", "Desenvolvimento de líderes", "Encontros práticos"],
  },
];

export const METHOD = [
  { t: "Diagnosticar", d: "Entender o cenário real: números, processos, pessoas e mercado." },
  { t: "Estruturar", d: "Desenhar a estratégia, o funil e os processos que vão sustentar o crescimento." },
  { t: "Executar", d: "Colocar o plano em prática, com responsáveis, prazos e rituais." },
  { t: "Mensurar", d: "Acompanhar indicadores que mostram o que está funcionando." },
  { t: "Otimizar", d: "Ajustar a rota continuamente para escalar o que gera resultado." },
];

export const MARKETS = [
  "Indústria", "Tecnologia", "Varejo", "Serviços", "Saúde", "Educação", "Agronegócio", "Construção",
];

export const EDUCATION = [
  { k: "[placeholder] MBA", v: "Estratégia de Marketing e Vendas" },
  { k: "[placeholder] Pós-graduação", v: "Gestão de Negócios" },
  { k: "[placeholder] Graduação", v: "Administração / Marketing" },
  { k: "[placeholder] Certificação", v: "Liderança de Equipes" },
];

export const ARTICLES = [
  { t: "[placeholder] Por que empresas com produto excelente ainda vendem pouco?", tag: "Estratégia" },
  { t: "[placeholder] Como reduzir o CAC gerando mais oportunidades comerciais", tag: "Vendas" },
  { t: "[placeholder] Marketing e Comercial: o custo de operar em silos", tag: "Marketing" },
];

export const FAQS = [
  { q: "Para quais tipos de empresa você atua?", a: "[placeholder] Empresas que já vendem e querem crescer com mais direção, de pequenas a médias e grandes, em diferentes setores." },
  { q: "Como funciona o processo de consultoria?", a: "[placeholder] Começamos com um diagnóstico, definimos o plano e acompanhamos a execução com indicadores claros, seguindo as 5 etapas do método." },
  { q: "Quanto tempo leva para ver resultados?", a: "[placeholder] Os primeiros ganhos costumam aparecer nas primeiras semanas de execução; resultados estruturais se consolidam ao longo dos meses." },
  { q: "Qual é o seu diferencial?", a: "[placeholder] Conectar marketing e comercial em um único sistema, com estratégia aplicada na prática e não apenas no papel." },
  { q: "O atendimento é presencial ou online?", a: "[placeholder] Os dois formatos são possíveis, de acordo com a necessidade da sua empresa." },
];

export const LINKS = {
  whatsapp: "#contato",
  linkedin: "#artigos",
  email: "#contato",
};
